import { styled } from '@mui/material';
import { Table, TableCell, TableRow } from '@mui/material';

export const StyledTable = styled(Table)(({ theme }) => ({
  minWidth: 650,
  tableLayout: 'auto',
}));

export const StyledTableHeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 2),
  textAlign: 'left',
  fontWeight: 600,
  whiteSpace: 'nowrap',
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },

  '&:last-child td': {
    borderBottom: 'none',
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(1.75, 2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  textAlign: 'left',
}));

export const CellContent = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));
